<template>
  <el-container>
    <el-header height="auto">
      <h2>Fichiers</h2>
      <path-breadcrumbs v-model="path" @input="refresh" class="breadcrumbs" />
    </el-header>

    <el-main>
      <div class="actions">
        <add-node
          @new="refresh"
          :dir="path.length ? path[path.length - 1] : null"
        />
      </div>

      <el-table
         :data="files"
         :stripe="true"
         :row-class-name="rowClassName"
         @row-dblclick="openDir" >
        <el-table-column label="Type" prop="type" :sortable="true" >
          <template slot-scope="{row}" >
            <i :class="fileIcon(row)"/>
            <span v-if="row.type === 'dir'">Dossier</span>
            <span v-if="row.type === 'file'">Fichier</span>
          </template>
        </el-table-column>
        <el-table-column label="Rôle" prop="node.flag" :sortable="true" />
        <el-table-column label="Nom" prop="name" :sortable="true" />
        <el-table-column label="Taille" prop="size" :sortable="true" >
          <template slot-scope="{row}" >
            {{ row.humanizeSize }}
          </template>
        </el-table-column>
        <el-table-column label="Dernière modification" prop="lastUpdate" :sortable="true" >
          <template slot-scope="{row}" >
            {{ row.lastUpdate.calendar() }}
          </template>
        </el-table-column>
        <el-table-column label="Auteur" prop="authorName" :sortable="true" />
        <el-table-column label="Actions"  min-width="90">
          <template slot-scope="{row}" >
            <el-button-group>
              <el-button
                 v-if="row.type === 'file'"
                 type="primary"
                 icon="el-icon-download"
                 @click="download(row)"
                 size="small"
                 />
              <node-detail
                 size="small"
                 @edit="refresh"
                 :node="row"
                 :dir="path.length ? path[path.length - 1] : null" />
              <el-button
                 size="small"
                 type="danger"
                 icon="el-icon-delete"
                 :disabled="row.node.flag !== null"
                 @click="nodeToDelete = row" />
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="Suppression" :visible="!!nodeToDelete">
        <div>Supprimer {{ nodeToDelete && nodeToDelete.name}} ?</div>
        <div slot="footer" >
          <el-button @click="nodeToDelete = null" type="warning" icon="el-icon-close" >Annuler</el-button>
          <el-button @click="deleteNode(nodeToDelete)" type="success" icon="el-icon-check" >Valider</el-button>
        </div>
      </el-dialog>
    </el-main>
  </el-container>
</template>

<script>
import {api} from 'macarons'
import {entityCollectionWrap} from '@/utils'
import {NodeVersion} from '../entity'
import AddNode from './AddNode'
import NodeDetail from './NodeDetail'
import PathBreadcrumbs from './PathBreadcrumbs'

export default {
  data () {
    return {
      path: [],
      files: [],
      refreshTimeout: null,
      refreshRate: 60000,
      nodeToDelete: null
    }
  },
  mounted () {
    this.refresh()
  },
  computed: {
    contract () {
      return this.$store.state.chloe.contract
    }
  },
  watch: {
    contract () {
      this.refresh()
    }
  },
  methods: {
    list () {
      return api.get(
        (this.path.length ? 'fs/node/' + this.path[this.path.length - 1].node.id : 'fs') + '/list'
      ).then(({data}) => {
        this.files.splice(0, this.files.length, ...entityCollectionWrap(data, NodeVersion))
      })
    },
    refresh () {
      clearTimeout(this.refreshTimeout)
      return Promise.all([
        this.list(),
        new Promise((resolve, reject) => {
          const cancelTimeout = setTimeout(reject, this.refreshRate + 1000)
          this.refreshTimeout = setTimeout(() => {
            clearTimeout(cancelTimeout)
            resolve()
          }, this.refreshRate)
        })
      ]).then(this.refresh).catch(() => {})
    },
    openDir (nodeVersion) {
      if (nodeVersion.type === 'dir') {
        this.path.push(nodeVersion)
        this.refresh()
      }
    },
    deleteNode (nodeVersion) {
      this.nodeToDelete = null
      api.delete('fs/node/' + nodeVersion.node.id)
        .then(this.refresh)
    },
    download (nodeVersion) {
      api.get('fs/download-token').then(({data}) => {
        window.location = api.defaults.baseURL.replace(/\/+$/g, '') +
          '/fs/node/' + nodeVersion.node.id + '/download?token=' + data.value
      })
    },
    rowClassName ({row}) {
      return 'type-' + row.type
    },
    fileIcon (file) {
      return {
        'el-icon-fa-folder-open': file.type === 'dir',
        'el-icon-fa-file': file.type === 'file'
      }
    }
  },
  beforeDestroy () {
    clearTimeout(this.refreshTimeout)
  },
  components: {
    AddNode,
    NodeDetail,
    PathBreadcrumbs
  }
}
</script>

<style scoped>
.el-header .breadcrumbs {
    flex: 1;
    margin: 0.4em 1em;
}
.el-table >>> tr.type-dir {
    cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/files/components/Files.vue